import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import logo from "@/assets/logo.svg";

export const MarketingFooter = () => {
  const navigate = useNavigate();

  return (
    <footer className="border-t border-border/40 bg-muted/30 mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img src={logo} alt="Vocalzing logo" className="h-10 w-10" />
              <h3 className="text-xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                Vocalzing
              </h3>
            </div>
            <p className="text-sm text-muted-foreground">
              Professional vocal coaching for everyone, everywhere.
            </p>
          </div>

          {/* Platform Links */}
          <div className="space-y-4">
            <h4 className="font-semibold">Platform</h4>
            <div className="flex flex-col gap-2">
              <Button variant="link" className="justify-start p-0 h-auto" onClick={() => navigate("/about")}>
                About Us
              </Button>
              <Button variant="link" className="justify-start p-0 h-auto" onClick={() => navigate("/pricing")}>
                Pricing
              </Button>
              <Button variant="link" className="justify-start p-0 h-auto" onClick={() => navigate("/apply-as-coach")}>
                Become a Coach
              </Button>
            </div>
          </div>

          {/* Resources Links */}
          <div className="space-y-4">
            <h4 className="font-semibold">Resources</h4>
            <div className="flex flex-col gap-2">
              <Button variant="link" className="justify-start p-0 h-auto" onClick={() => navigate("/auth")}>
                Sign In
              </Button>
              <Button variant="link" className="justify-start p-0 h-auto" onClick={() => navigate("/auth")}>
                Get Started
              </Button>
            </div>
          </div>

          {/* Legal Links */}
          <div className="space-y-4">
            <h4 className="font-semibold">Legal</h4>
            <div className="flex flex-col gap-2">
              <Button variant="link" className="justify-start p-0 h-auto" onClick={() => navigate("/terms")}>
                Terms of Service
              </Button>
              <Button variant="link" className="justify-start p-0 h-auto" onClick={() => navigate("/privacy")}>
                Privacy Policy
              </Button>
            </div>
          </div>
        </div>

        <Separator className="my-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Vocalzing. All rights reserved.
          </p>
          <p className="text-sm text-muted-foreground">
            Made with ❤️ for vocalists worldwide
          </p>
        </div>
      </div>
    </footer>
  );
};
